import React, { useState, useEffect } from 'react';
import url from "../../services/url";
import {
  Card,
  Typography,
  Input,
  Empty,
  Row,
  Col,
  Alert,
  Spin,
  Switch,
  Button,
  List,
  Modal,
  Form,
  message,
  Select,
  Input as AntdInput
} from 'antd';
import styled from 'styled-components';
import Dashboard from '../../layouts/Dashboard';
import { checkPermission } from '../../utils/checkPermission';
import useRole from '../../hooks/useRole';
import saveLog from "../../services/saveLog";
import useAxios from '../../hooks/useAxios';

const { Search } = Input;
const { Title, Text } = Typography;



const ENTITIES = {
  application_module: {
    name: "application_module",
    displayName: "Application",
    permissions: [
      { name: "add_new", displayName: "Add New" },
      { name: "export", displayName: "Export" },
      { name: "application_proceed", displayName: "Application Proceed" },
      { name: "not_fit", displayName: "Not Fit" },
      { name: "application_authorized_dump_download", displayName: "Application Authorized Dump Download" },
      { name: "export_to_ameyo", displayName: "Export to Ameyo" },
      { name: "total_walkin", displayName: "Total Walk-in" },
      { name: "status", displayName: "Status" }
    ]
  },
  bulk_upload_module: {
    name: "bulk_upload_module",
    displayName: "Bulk Upload",
    permissions: [
      { name: "view_bulk_upload", displayName: "View Bulk Upload" },
      { name: "upload_csv", displayName: "Upload CSV" },
      //  { name: "download_csv_sample", displayName: "Download CSV Sample" },
      // { name: "manual_create_application", displayName: "Manual Create Application" }
    ]
  },
  voice_bot_upload_module: {
    name: "voice_bot_upload_module",
    displayName: "Voice Bot Upload",
    permissions: [
      { name: "view_voice_bot_upload", displayName: "View Voice Bot Upload" },
      { name: "voice_bot_upload", displayName: "Voice Bot Upload" },
      { name: "download_voice_bot_sample", displayName: "Download Voice Bot Sample" },
    ]
  },
  formbuilder_module: {
    name: "formbuilder_module",
    displayName: "Form Builder",
    permissions: [
      { name: "create", displayName: "Create" },
      { name: "view_form_builder", displayName: "View Form Builder" }
    ]
  },
  forms_module: {
    name: "forms_module",
    displayName: "Forms",
    permissions: [
      { name: "copy_form", displayName: "Copy Form" },
      { name: "duplicate_form", displayName: "Duplicate Form" },
      { name: "edit_form", displayName: "Edit Form" },
      { name: "view_form", displayName: "View Form" },
    ]
  },
  trf_module: {
    name: "trf_module",
    displayName: "TRF",
    permissions: [
      { name: "view_trf", displayName: "View TRF" },
      { name: "export", displayName: "Export" },
      { name: "view_trf_details", displayName: "View TRF Details" },
      { name: "getusers", displayName: "Search TRF" }
    ]
  },
  assign_trf_module: {
    name: "assign_trf_module",
    displayName: "Assign TRF",
    permissions: [
      { name: "view_assign_trf", displayName: "View Assign TRF" },
      { name: "allocate_trf", displayName: "Allocate TRF" }
    ]
  },
  process_based_versant_module: {
    name: "process_based_versant_module",
    displayName: "Versant Configuration",
    permissions: [
      { name: "delete", displayName: "Delete" },
      { name: "create", displayName: "Create" },
      { name: "view_versant", displayName: "View Versant" },
      { name: "edit", displayName: "Edit" }
    ]
  },
  tin_usage_report_module: {
    name: "tin_usage_report_module",
    displayName: "TIN Usage Report",
    permissions: [
      { name: "export", displayName: "Export" },
      { name: "view_tin_usage", displayName: "View Tin Usage" },
      { name: "view_tin_report", displayName: "View TIN Report" },
      { name: "sync", displayName: "Sync New TINs" }
    ]
  },
  // tin_access_manangement_module: {
  //   name: "tin_access_manangement_module",
  //   displayName: "TIN Access Management",
  //   permissions: [
  //     { name: "view_tin_report", displayName: "View Tin Report" },
  //     { name: "submit", displayName: "Submit" },
  //   ]
  // },
  documents_module: {
    name: "documents_module",
    displayName: "Documents",
    permissions: [
      { name: "view_documents", displayName: "View Documents" },
      { name: "onboard", displayName: "Onboard" },
      { name: "adhaar_verification_accept_reject", displayName: "Adhaar Verification Accept/Reject" },
      { name: "pan_verification_accept_reject", displayName: "PAN Verification Accept/Reject" },
      { name: "doc_images_accept_reject", displayName: "Document Images Accept/Reject" },
      { name: "bank_verification_accept_reject", displayName: "Bank Verification Accept/Reject" },
      { name: "bank_verification_button", displayName: "Bank Verification Button" },
      { name: "candidate_info_accept_reject", displayName: "Candidate Info Accept/Reject" },
      { name: "professional_exp_accept_reject", displayName: "Professional Experience Accept/Reject" },
      { name: "candidate_document_form_submit", displayName: "Candidate Document Form Submit" },
      { name: "final_approve", displayName: "Final Approve" },
      { name: "uan_submit", displayName: "UAN Submit" }
    ]
  },
  create_document_module: {
    name: "create_document_module",
    displayName: "Create Document",
    permissions: [
      { name: "create", displayName: "Create" },
      { name: "edit", displayName: "Edit" },
      { name: "delete", displayName: "Delete" },
      { name: "view", displayName: "View" },
      { name: "view_document", displayName: "View Document" }
    ]
  },
  candidate_profile_module: {
    name: "candidate_profile_module",
    displayName: "Candidate Profile",
    permissions: [
      { name: "call_discussion_view", displayName: "Call Discussion View" },
      { name: "call_discussion_save", displayName: "Call Discussion Save" },
      { name: "trf_details_edit", displayName: "TRF Details Edit/Submit" },
      { name: "candidate_details_edit", displayName: "Candidate Details Edit" },
      { name: "additional_info_edit", displayName: "Additional Info Edit" },
      { name: "resume_cv", displayName: "Resume / Video Message" },
      { name: "arrange_interview", displayName: "Arrange Interview" },
      { name: "non_agent_docs_send", displayName: "Non-Agent Docs Send" },
      { name: "history_view", displayName: "History View" },
      { name: "proceed_with_document", displayName: "Proceed With Document" },
      { name: "take_interview", displayName: "Take Interview" },
      { name: "make_interview_editable", displayName: "Make Interview Editable" },
      { name: "special_trf_edit", displayName: "Special TRF Edit" }
    ]
  },

  site_hr_audit_document_module: {
    name: "site_hr_audit_document_module",
    displayName: "Site HR Audit Document",
    permissions: [
      { name: "view_site_hr_audit_document", displayName: "View Site HR Audit Document" },
      { name: "reupload_site_hr_audit_document", displayName: "Reupload Site HR Audit Document" },
      { name: "no_problem_site_hr_audit_document", displayName: "No Problem Site HR Audit Document" },
      { name: "download_site_hr_audit_document", displayName: "Download Site HR Audit Document" },
      { name: "print_site_hr_audit_document", displayName: "Print Site HR Audit Document" },
    ]
  },

  central_hr_audit_document_module: {
    name: "central_hr_audit_document_module",
    displayName: "Central HR Audit Document",
    permissions: [
      { name: "view_central_hr_audit_document", displayName: "View Central HR Audit Document" },
      { name: "accept_central_hr_audit_document", displayName: "Accept Central HR Audit Document" },
      { name: "reject_central_hr_audit_document", displayName: "Reject Central HR Audit Document" },
      { name: "download_central_hr_audit_document", displayName: "Download Central HR Audit Document" },
      { name: "print_central_hr_audit_document", displayName: "Print Central HR Audit Document" },
      { name: "submit_central_hr_audit_document", displayName: "Submit Central HR Audit Document" }
    ]
  },

  analytics_dashboard_module: {
    name: "analytics_dashboard_module",
    displayName: "Analytics Dashboard",
    permissions: [
      { name: "view_interview_dashboard", displayName: "View Recruiter Dashboard" },
      { name: "view_admin_dashboard", displayName: "View Admin Dashboard" },
    ]
  },
  competency_setup_module: {
    name: "competency_setup_module",
    displayName: "Competency Setup",
    permissions: [
      { name: "view_competency_setup", displayName: "View Competency Setup" },
      { name: "create_competency_interview_round", displayName: "Create Competency Interview Round" },
      { name: "edit_competency_interview_round", displayName: "Edit Competency Interview Round" },
      { name: "delete_competency_interview_round", displayName: "Delete Competency Interview Round" },
      { name: "create_Competencies", displayName: "Create Competencies" },
      { name: "edit_Competencies", displayName: "Edit Competencies" },
      { name: "delete_Competencies", displayName: "Delete Competencies" },
      { name: "create_competency_question_bank", displayName: "Create Competency Question Bank" },
      { name: "edit_competency_question_bank", displayName: "Edit Competency Question Bank" },
      { name: "delete_competency_question_bank", displayName: "Delete Competency Question Bank" },
      { name: "create_competency_binding", displayName: "Create Competency Binding" },
      { name: "add_competency_interview_setup", displayName: "Add Competency Interview Setup" },
      { name: "edit_competency_interview_setup", displayName: "Edit Competency Interview Setup" },
      { name: "delete_competency_interview_setup", displayName: "Delete Competency Interview Setup" },
      { name: "submit_competency_interview_setup", displayName: "Submit Competency Interview Setup" }
    ]
  },
  interview_status_module: {
    name: "interview_status_module",
    displayName: "Interview Status",
    permissions: [
      { name: "create_status", displayName: "Create Status" },
      { name: "create_status_reason", displayName: "Create Status Reason" },
      { name: "edit_status", displayName: "Edit Status" },
      { name: "delete_status", displayName: "Delete Status" },
      { name: "view_interview_status", displayName: "View Interview Status" }
    ]
  },
  client_mapping_module: {
    name: "client_mapping_module",
    displayName: "Client Mapping",
    permissions: [
      { name: "create_client_mapping", displayName: "Create Client Mapping" },
      // { name: "delete_client_mapping", displayName: "Delete Client Mapping" },
      { name: "edit_client_mapping", displayName: "Edit Client Mapping" },
      //  { name: "edit_status_client_mapping", displayName: "Edit Status Client Mapping" },
      { name: "view_client_mapping", displayName: "View Client Mapping" }
    ]
  },
  consultant_mapping_module: {
    name: "consultant_mapping_module",
    displayName: "Consultant Mapping",
    permissions: [
      { name: "create_consultant_mapping", displayName: "Create Consultant Mapping" },
      { name: "edit_consultant_mapping", displayName: "Edit Consultant Mapping" },
      { name: "edit_status_consultant_mapping", displayName: "Edit Status Consultant Mapping" },
      { name: "view_consultant_mapping", displayName: "View Consultant Mapping" }
    ]
  },
  call_status_module: {
    name: "call_status_module",
    displayName: "Call Status",
    permissions: [
      { name: "create_call_master", displayName: "Create Call Master" },
      { name: "create_call_status_master", displayName: "Create Call Status Master" },
      { name: "create_call_status_parameters_master", displayName: "Create Call Status Parameters Master" },
      { name: "create_call_status_sub_parameters_master", displayName: "Create Call Status Sub Parameters Master" },
      { name: "edit_call_status", displayName: "Edit Call Status" },
      { name: "delete_call_status", displayName: "Delete Call Status" },
      { name: "view_call_status", displayName: "View Call Status" }
    ]
  },
  application_report_module: {
    name: "application_report_module",
    displayName: "Application Report",
    permissions: [
      { name: "view_application_report", displayName: "View Application Report" },
      { name: "download_application_report", displayName: "Download Application Report" },
      // { name: "view_agent", displayName: "View Agent" },
      { name: "view_non_agent", displayName: "View Non-Agent" },
      { name: "view_new_leads", displayName: "View New-Leads" },
    ]
  },
  audit_report_module: {
    name: "audit_report_module",
    displayName: "Audit Report",
    permissions: [
      { name: "view_audit_report", displayName: "View Audit Report" },
      { name: "download_audit_report", displayName: "Download Audit Report" }
    ]
  },
  interview_logs_module: {
    name: "interview_logs_module",
    displayName: "Interview Logs",
    permissions: [
      { name: "view_interview_logs", displayName: "View Interview Logs" },
      { name: "download_interview_logs", displayName: "Download Interview Logs" },
      { name: "interview_download_authorized_dump", displayName: "Authorized Mobile Number Export" }
    ]
  },
  otp_logs_module: {
    name: "otp_logs_module",
    displayName: "OTP Logs",
    permissions: [
      { name: "view_otp_logs", displayName: "View OTP Logs" },
      { name: "download", displayName: "Download" }
    ]
  },
  feedback_report_module: {
    name: "feedback_report_module",
    displayName: "Feedback Report",
    permissions: [
      { name: "view_feedback_report", displayName: "View Feedback Report" },
      { name: "download", displayName: "Download" }
    ]
  },
  login_report_module: {
    name: "login_report_module",
    displayName: "Login Report",
    permissions: [
      { name: "view_login_report", displayName: "View Login Report" },
      { name: "download_login_report", displayName: "Download Login Report" }
    ]
  },
  distributed_trf_report_module: {
    name: "distributed_trf_report_module",
    displayName: "Distributed TRF Report",
    permissions: [
      { name: "view_distributed_trf", displayName: "View Distributed TRF" },
      { name: "download_distributed_trf", displayName: "Download Distributed TRF" }
    ]
  },
  document_report_module: {
    name: "document_report_module",
    displayName: "Document Report",
    permissions: [
      { name: "view_document_report", displayName: "View Document Report" },
      { name: "download_document_report", displayName: "Download Document Report" }
    ]
  },
  ai_report_module: {
    name: "ai_report_module",
    displayName: "AI Report",
    permissions: [
      { name: "view_ai_report", displayName: "View AI Report" },
      { name: "download_ai_report", displayName: "Download AI Report" }
    ]
  },
  manage_users_module: {
    name: "manage_users_module",
    displayName: "Manage Users",
    permissions: [
      { name: "view_users", displayName: "View Users" },
      { name: "change_role", displayName: "Change Role" },
      { name: "change_status", displayName: "Change Status" },
      { name: "register_user", displayName: "Register User" }
    ]
  },
  // register_user_module: {
  //   name: "register_user_module",
  //   displayName: "Register User",
  //   permissions: [
  //     { name: "view_register", displayName: "View Register" },
  //     { name: "register_user", displayName: "Register User" }
  //   ]
  // },
  logs_module: {
    name: "logs_module",
    displayName: "Logs",
    permissions: [
      { name: "view_logs", displayName: "View Logs" },
      { name: "download_logs", displayName: "Download Logs" }
    ]
  },
  api_logs_module: {
    name: "api_logs_module",
    displayName: "API Logs",
    permissions: [
      { name: "view_api_logs", displayName: "View API Logs" },
      { name: "submit_api_logs", displayName: "Submit API Logs" }
    ]
  },
  service_setting_module: {
    name: "service_setting_module",
    displayName: "Service Setting",
    permissions: [
      { name: "view_service_settings", displayName: "View Service Settings" },
      { name: "edit_service_settings", displayName: "Edit Service Settings" },
      { name: "submit_service_settings", displayName: "Submit Service Settings" }
    ]
  },
  settings_module: {
    name: "settings_module",
    displayName: "Settings",
    permissions: [
      { name: "view_settings", displayName: "View Settings" },
      { name: "reasons_for_rejection_add", displayName: "Add Reasons for Rejection" },
      { name: "reasons_for_rejection_delete", displayName: "Delete Reasons for Rejection" },
      { name: "source_for_contacts_add", displayName: "Add Source for Contacts" },
      { name: "source_for_contacts_delete", displayName: "Delete Source for Contacts" },
      { name: "query_types_add", displayName: "Add Query Types" },
      { name: "query_types_delete", displayName: "Delete Query Types" },
      { name: "loan_providers_add", displayName: "Add Loan Providers" },
      { name: "loan_providers_delete", displayName: "Delete Loan Providers" },
      { name: "loan_providers_save", displayName: "Save Loan Providers" },
      { name: "reminder_settings_save", displayName: "Save Reminder Settings" }
    ]
  },
  generate_excel_module: {
    name: "generate_excel_module",
    displayName: "Generate Excel",
    permissions: [
      { name: "view_generate_excel", displayName: "View Generate Excel" },
      { name: "generate_excel", displayName: "Generate Excel" }
    ]
  },
  // candidate_portal: {
  //   name: "candidate_portal",
  //   displayName: "Candidate Portal",
  //   permissions: [
  //     { name: "full_access", displayName: "Full Access" }
  //   ]
  // },

  admin_module: {
    name: "admin_module",
    displayName: "Roles & Permissions",
    permissions: [
      { name: "view_admin", displayName: "View Admin" },
      { name: "save_user", displayName: "Save User" },
      { name: "create_role", displayName: "Create role" }
    ]
  },
  generate_qr_code_module: {
    name: "generate_qr_code_module",
    displayName: "Generate QR Code",
    permissions: [
      { name: "view_qr_code", displayName: "View QR Code" },
      { name: "generate_qr_code", displayName: "Generate QR Code" }
    ]
  },
  ai_service_module: {
    name: "ai_service_module",
    displayName: "AI Service",
    permissions: [
      { name: "view_ai_service", displayName: "View AI Service" },
      { name: "toggle_ai_service", displayName: "Toggle AI Service" }
    ]
  },
  ameyo_service_module: {
    name: "ameyo_service_module",
    displayName: "Ameyo Service",
    permissions: [
      { name: "view_ameyo_service", displayName: "View Ameyo Service" },
      { name: "toggle_ameyo_service", displayName: "Toggle Ameyo Service" }
    ]
  },
  manager_dashboard_module: {
    name: "manager_dashboard_module",
    displayName: "Manager Dashboard",
    permissions: [
      { name: "view_permission", displayName: "View Manager Dashboard" },
      { name: "view_unassigned_leads", displayName: "View Unassigned Leads Button" },
      { name: "add_existing_rule", displayName: "Add Existing Rule" },
      { name: "create_new_rule", displayName: "Create New Rule" }
    ]
  },
  rule_engine_module: {
    name: "rule_engine_module",
    displayName: "Rule Engine",
    permissions: [
      { name: "view_rule", displayName: "View Rule Engine" },
      { name: "create_rule", displayName: "Create Rule" },
      { name: "edit_rule", displayName: "Edit Rule" },
      { name: "copy_rule", displayName: "Copy Rule" },
      { name: "delete_rule", displayName: "Delete Rule" },
      { name: "transfer_leads", displayName: "Transfer Leads" }
    ]
  },
  ameyo_configuration_module: {
    name: "ameyo_configuration_module",
    displayName: "Ameyo Configuration",
    permissions: [
      { name: "view_ameyo_configuration", displayName: "View Ameyo Configuration" },
      { name: "add_ameyo_campaign", displayName: "Add Campaign" },
      { name: "edit_ameyo_campaign", displayName: "Edit Campaign" },
      { name: "delete_ameyo_campaign", displayName: "Delete Campaign" }
    ]
  }
};
const StyledAdmin = styled.div`
  .ant-btn {
    &:hover, &:focus {
      color: #f58220;
      border-color: #f58220;
    }
  }

  .ant-btn-primary {
    background: linear-gradient(135deg, #f58220 0%, #fbaf40 100%);
    border: none;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: auto;
    padding: 8px 24px;
    font-weight: 500;
    
    &:hover, &:focus {
      background: linear-gradient(135deg, #fbaf40 0%, #f58220 100%);
      color: white;
      opacity: 0.9;
      border: none;
    }
    
    .anticon {
      font-size: 18px;
      color: white;
    }
  }
  .ant-switch-checked {
    background-color: #f58220;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: #f58220;
    box-shadow: 0 0 0 2px rgba(245, 130, 32, 0.2);
  }
  
  /* Override for text buttons or secondary buttons */
  .ant-btn:not(.ant-btn-primary) {
    color: #f58220;
    border-color: #f58220;
    
    &:hover, &:focus {
      background-color: #fff7e6;
    }
  }
`;

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedModule, setSelectedModule] = useState('');
  const [modulePermissions, setModulePermissions] = useState({});
  const [initialPermissions, setInitialPermissions] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createForm] = Form.useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [moduleSearchValue, setModuleSearchValue] = useState('');


  const [canCreateRole, setCanCreateRole] = useState(false);
  const [canSavePermissions, setCanSavePermissions] = useState(false);
  const userRole = useRole();
  const api = useAxios();

  const checkAdminPermissions = async () => {
    try {
      const createRole = await checkPermission(
        userRole,
        "admin_module",
        "create_role"
      );
      const savePermissions = await checkPermission(
        userRole,
        "admin_module",
        "save_user"
      );

      setCanCreateRole(createRole);
      setCanSavePermissions(savePermissions);
    } catch (error) {
      console.error("Permission check failed for Admin:", error);
      setCanCreateRole(false);
      setCanSavePermissions(false);
    }
  };

  // Run on user role change
  useEffect(() => {
    checkAdminPermissions();
  }, [userRole]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleCreateRole = async (values) => {
    try {
      setCreateLoading(true);
      const response = await api.post("/role", {
        roleName: values.roleName,
        status: true
      }, {
        tokenType: "user"
      });

      if (response.data) {
        message.success('Role created successfully');
        fetchRoles();
        setIsCreateModalOpen(false);
        createForm.resetFields();
      }
    } catch (error) {
      console.error("Error creating role:", error);
      message.error(`Failed to create role: ${error.response?.data?.message || error.message}`);
    } finally {
      setCreateLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {
      setRolesLoading(true);
      setError(null);

      const response = await api.get("/role", {
        tokenType: "user"
      });
      setAllRoles(response.data.roleMaster);
      console.log("Fetched roles:", response.data.roleMaster);
    } catch (error) {
      console.error("Error fetching roles:", error);
      setError(`Failed to fetch roles: ${error.response?.data?.message || error.message}`);
      setAllRoles([]);
    } finally {
      setRolesLoading(false);
    }
  };

  const searchRoles = (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }
    setSearching(true);
    const filtered = allRoles.filter((role) => {
      const q = query.toLowerCase();
      return Object.values(role).some((val) =>
        typeof val === "string" ? val.toLowerCase().includes(q) : false
      );
    });
    setSearchResults(filtered);
    setSearching(false);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    searchRoles(value);
  };

  const handleRoleSelect = async (role) => {

    // If there are unsaved changes, show confirmation dialog
    if (hasChanges) {
      Modal.confirm({
        title: 'Unsaved Changes',
        content: 'You have unsaved changes. Are you sure you want to switch roles without saving?',
        okText: 'Yes, switch anyway',
        cancelText: 'No, stay here',
        okButtonProps: { style: { backgroundColor: '#f58220', borderColor: '#f58220', color: 'white' } },
        onOk: () => {
          // User confirmed, switch roles
          performRoleSwitch(role);
        },
        onCancel: () => {
          // User cancelled, do nothing
        },
      });
    } else {
      // No unsaved changes, proceed with role switch
      performRoleSwitch(role);
    }
  };

  const performRoleSwitch = (role) => {
    setSelectedRole(role.roleName);
    setSelectedModule('');
    setModulePermissions({});
    setInitialPermissions({});
    setHasChanges(false);
  };

  const handleModuleSelect = async (module) => {
    // If there are unsaved changes, show confirmation dialog
    if (hasChanges) {
      Modal.confirm({
        title: 'Unsaved Changes',
        content: 'You have unsaved changes. Are you sure you want to switch modules without saving?',
        okText: 'Yes, switch anyway',
        cancelText: 'No, stay here',
        okButtonProps: { style: { backgroundColor: '#f58220', borderColor: '#f58220', color: 'white' } },
        onOk: async () => {
          // User confirmed, switch modules
          await switchToModule(module);
        },
        onCancel: () => {
          // User cancelled, do nothing
        },
      });
    } else {
      // No unsaved changes, proceed with module switch
      await switchToModule(module);
    }
  };

  const switchToModule = async (module) => {
    setSelectedModule(module);
    setLoading(true);
    setHasChanges(false);
    try {
      const response = await api.get(`/permify/?module=${module}`, {
        tokenType: "user"
      });

      const apiData = response.data.result;
      console.log("permissions", apiData)
      console.log(selectedRole)
      const roleName = selectedRole;
      console.log("Selected role:", roleName);
      const rolePermissions = apiData[roleName] || [];

      const initialPermissions = {};
      if (ENTITIES[module] && ENTITIES[module].permissions) {
        ENTITIES[module].permissions.forEach(permission => {
          initialPermissions[permission.name] = rolePermissions.includes(permission.name);
        });
      }

      setModulePermissions(initialPermissions);
      setInitialPermissions(initialPermissions);
      setError("");
    } catch (err) {
      console.error("Failed to fetch module permissions:", err);
      setError("Failed to fetch module permissions. Please try again.");
      const initialPermissions = {};
      if (ENTITIES[module] && ENTITIES[module].permissions) {
        ENTITIES[module].permissions.forEach(permission => {
          initialPermissions[permission.name] = false;
        });
      }
      setModulePermissions(initialPermissions);
      setInitialPermissions(initialPermissions);
    } finally {
      setLoading(false);
    }
  };

  const handlePermissionToggle = (permission, value) => {
    const newPermissions = {
      ...modulePermissions,
      [permission]: value
    };
    setModulePermissions(newPermissions);

    // Check if the new permissions are different from initial permissions
    const hasChanges = Object.entries(newPermissions).some(
      ([key, val]) => initialPermissions[key] !== val
    );
    setHasChanges(hasChanges);
  };

  const savePermissions = async () => {
    if (!selectedRole || !selectedModule || !hasChanges) return;

    setSaving(true);
    setLoading(true);

    try {
      const roleName = selectedRole;
      const changedPermissions = [];
      for (const [permissionName, isEnabled] of Object.entries(modulePermissions)) {
        const wasEnabled = initialPermissions[permissionName] || false;
        if (isEnabled !== wasEnabled) {
          changedPermissions.push({
            name: permissionName,
            type: isEnabled ? "added" : "deleted"
          });
        }
      }

      if (changedPermissions.length === 0) {
        setError("");
        setLoading(false);
        message.info("No changes to save.");
        return;
      }

      const payload = {
        module: selectedModule,
        permissions: [
          {
            role: roleName,
            changedPermissions
          }
        ]
      };

      const response = await api.put(
        "permify",
        payload,
        {
          tokenType: "user"
        }
      );
      if (response.status === 200) {
        setInitialPermissions({ ...modulePermissions });
        setError("");
        setHasChanges(false); // Reset hasChanges after successful save
        message.success("Permissions updated successfully!");

        // Log the changes
        for (const change of changedPermissions) {
          const permission = ENTITIES[selectedModule].permissions.find(p => p.name === change.name);
          const permissionLabel = permission ? permission.displayName : change.name;
          const moduleLabel = ENTITIES[selectedModule].displayName || selectedModule;
          const description = `Permissions updated for role: ${roleName} | Module: ${moduleLabel} | Permission: ${permissionLabel} set to ${change.type === 'added' ? 'Enabled' : 'Disabled'}`;
          saveLog("Permission Update", description);
        }
      }
    } catch (err) {
      console.error('Error saving permissions:', err);
      message.error('Failed to save permissions. Please try again.');
    } finally {
      setSaving(false);
      setLoading(false);
    }
  };

  if (rolesLoading) {
    return (
      <div style={{
        padding: "20px",
        textAlign: "center",
        minHeight: "400px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div>
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>
            <Text style={{ fontSize: 16, color: "#666" }}>Loading roles...</Text>
          </div>
        </div>
      </div>
    );
  }

  return (
    <StyledAdmin>
      <Dashboard title="admin">
        <div style={{
          padding: window.innerWidth <= 768 ? "4px" : "8px",
          background: "#f5f7fa",
          minHeight: "100vh"
        }}>
          <div style={{
            maxWidth: "1400px",
            margin: "0 auto"
          }}>
            <Title
              level={window.innerWidth <= 480 ? 3 : 2}
              style={{
                marginBottom: window.innerWidth <= 768 ? 16 : 32,
                color: "#2c3e50",
                textAlign: window.innerWidth <= 480 ? "center" : "left",
                fontSize: window.innerWidth <= 480 ? "20px" : undefined
              }}
            >
              User Access Management
            </Title>

            {error && (
              <Alert
                message="Error"
                description={error}
                type="error"
                showIcon
                closable
                style={{
                  marginBottom: window.innerWidth <= 768 ? 16 : 24,
                  borderRadius: 8
                }}
                onClose={() => setError("")}
              />
            )}

            {/* Search roles - only show when no role is selected */}
            {!selectedRole && (
              <Card style={{
                marginBottom: window.innerWidth <= 768 ? 16 : 24,
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16
                }}>
                  <Text strong style={{
                    fontSize: window.innerWidth <= 480 ? 14 : 16,
                    color: "#2c3e50"
                  }}>
                    Search Roles ({allRoles.filter(role => role.roleName !== userRole).length} total)

                  </Text>
                  {canCreateRole && (
                    <Button
                      type="primary"
                      onClick={() => setIsCreateModalOpen(true)}
                      size={window.innerWidth <= 480 ? "middle" : "large"}
                    >
                      Create New Role
                    </Button>
                  )
                  }
                </div>
                <Select
                  showSearch
                  placeholder="Search and select a role..."
                  loading={rolesLoading}
                  size={window.innerWidth <= 480 ? "middle" : "large"}
                  style={{ width: '100%', marginBottom: 16 }}
                  onChange={(value) => {
                    const role = allRoles.find(r => r.roleName === value);
                    if (role) handleRoleSelect(role);
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) ||
                    (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={allRoles
                    .filter(role => role.roleName !== userRole)
                    .map(role => {
                      const isInterviewer =
                        role.roleName?.toLowerCase() === "interviewer";
                      return {
                        value: role.roleName,
                        label: isInterviewer ? "DH_Recruiters" : role.roleName
                      };
                    })}
                />

                {/* Create Role Modal */}
                <Modal
                  title="Create New Role"
                  open={isCreateModalOpen}
                  onCancel={() => {
                    setIsCreateModalOpen(false);
                    createForm.resetFields();
                  }}
                  footer={null}
                  destroyOnClose
                >
                  <Form
                    form={createForm}
                    onFinish={handleCreateRole}
                    layout="vertical"
                    style={{ marginTop: 6 }}
                  >
                    <Form.Item
                      name="roleName"
                      label="Role Name"
                      rules={[
                        { required: true, message: 'Please enter role name' },
                        { min: 2, message: 'Role name must be at least 2 characters' },
                        { pattern: /^[a-zA-Z_-]+$/, message: 'Role name cannot contain spaces or numbers' },
                        {
                          validator: (_, value) => {
                            if (value && allRoles.some(role => role.roleName.toLowerCase() === value.toLowerCase())) {
                              return Promise.reject('Role name already exists');
                            }
                            return Promise.resolve();
                          }
                        }
                      ]}
                    >
                      <AntdInput placeholder="Enter role name" />
                    </Form.Item>

                    <Form.Item>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button
                          onClick={() => {
                            setIsCreateModalOpen(false);
                            createForm.resetFields();
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={createLoading}
                          style={{
                            background: "#f58220",
                            borderColor: "#f58220",
                            color: "#fff"
                          }}
                        >
                          Create Role
                        </Button>
                      </div>
                    </Form.Item>
                  </Form>
                </Modal>
              </Card>
            )}

            {selectedRole ? (
              <Card style={{
                borderRadius: 12,
                boxShadow: "0 4px 16px rgba(0,0,0,0.1)"
              }}>
                <div style={{
                  marginBottom: window.innerWidth <= 768 ? 16 : 24,
                  padding: window.innerWidth <= 480 ? "16px" : "20px",
                  background: "#f0f2f5",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: window.innerWidth <= 480 ? "flex-start" : "center",
                  flexDirection: window.innerWidth <= 480 ? "column" : "row"
                }}>
                  <div style={{ marginBottom: window.innerWidth <= 480 ? 12 : 0 }}>
                    <Text strong style={{
                      fontSize: window.innerWidth <= 480 ? 16 : 18,
                      display: "block",
                      marginBottom: 8
                    }}>
                      Role: {(selectedRole?.toLowerCase() === "interviewer" || selectedRole?.toLowerCase() === "interview") ? "DH_Recruiters" : selectedRole}
                    </Text>

                  </div>
                  <Button
                    type="primary"
                    size={window.innerWidth <= 480 ? "small" : "middle"}
                    onClick={() => {
                      setSelectedRole(null);
                      setSelectedModule('');
                      setModulePermissions({});
                      setSearchValue('');
                      setSearchResults([]);
                      setModuleSearchValue('');
                    }}
                  >
                    Back to Search
                  </Button>
                </div>

                <Row gutter={window.innerWidth <= 768 ? [0, 16] : [24, 0]}>
                  <Col xs={24} md={8}>
                    <Card
                      title="Modules"
                      size="small"
                      style={{
                        height: window.innerWidth <= 768 ? "auto" : "500px",
                        overflow: "hidden"
                      }}
                    >
                      <div style={{ marginBottom: 12 }}>
                        <Search
                          placeholder="Search modules..."
                          value={moduleSearchValue}
                          onChange={(e) => setModuleSearchValue(e.target.value)}
                          allowClear
                          size="small"
                        />
                      </div>
                      <div style={{
                        height: window.innerWidth <= 768 ? "auto" : "370px",
                        maxHeight: window.innerWidth <= 768 ? "300px" : "370px",
                        overflowY: "auto"
                      }}>
                        <List
                          dataSource={Object.entries(ENTITIES).filter(([key, module]) =>
                            !moduleSearchValue.trim() ||
                            module.displayName.toLowerCase().includes(moduleSearchValue.trim().toLowerCase())
                          )}
                          locale={{ emptyText: <Empty description="No modules found" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                          renderItem={([key, module]) => (
                            <List.Item
                              onClick={() => handleModuleSelect(key)}
                              style={{
                                cursor: "pointer",
                                backgroundColor: selectedModule === key ? "#fff7e6" : "transparent",
                                borderRadius: 4,
                                padding: window.innerWidth <= 480 ? "8px" : "12px",
                                margin: "4px 0",
                                border: selectedModule === key ? "1px solid #ffa940" : "1px solid transparent",
                              }}
                              onMouseEnter={(e) => {
                                if (selectedModule !== key) {
                                  e.currentTarget.style.backgroundColor = "#f5f5f5";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (selectedModule !== key) {
                                  e.currentTarget.style.backgroundColor = "transparent";
                                }
                              }}
                            >
                              <Text
                                strong={selectedModule === key}
                                style={{ fontSize: window.innerWidth <= 480 ? 13 : 14 }}
                              >
                                {module.displayName}
                              </Text>
                            </List.Item>
                          )}
                        />
                      </div>
                    </Card>
                  </Col>

                  <Col xs={24} md={16}>
                    {selectedModule ? (
                      <Card
                        title={
                          <span style={{
                            fontSize: window.innerWidth <= 480 ? 14 : 16
                          }}>
                            {ENTITIES[selectedModule]?.displayName} Permissions
                          </span>
                        }
                        size="small"
                        style={{
                          height: window.innerWidth <= 768 ? "auto" : "500px",
                          overflow: "hidden"
                        }}
                        loading={loading}
                        extra={
                          !loading && (
                            canSavePermissions && (
                              <Button
                                type="primary"
                                onClick={savePermissions}
                                size={window.innerWidth <= 480 ? "small" : "small"}
                                disabled={!hasChanges || saving}
                                loading={saving}
                              >
                                {window.innerWidth <= 480 ? "Save" : "Save Permissions"}
                              </Button>
                            )
                          )
                        }
                      >
                        {!loading && (
                          <div style={{
                            height: window.innerWidth <= 768 ? "auto" : "420px",
                            maxHeight: window.innerWidth <= 768 ? "400px" : "420px",
                            overflowY: "auto"
                          }}>
                            {/* Toggle All Permissions */}
                            {ENTITIES[selectedModule]?.permissions?.length > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: window.innerWidth <= 480 ? "10px" : "12px 16px",
                                  background: "linear-gradient(135deg, #fff7e6, #fffbf0)",
                                  borderRadius: 8,
                                  marginBottom: 12,
                                  border: "1px solid #ffa940"
                                }}
                              >
                                <Text strong style={{ fontSize: window.innerWidth <= 480 ? 13 : 14, color: "#f57921" }}>
                                  {(() => {
                                    const visiblePermissions = ENTITIES[selectedModule]?.permissions?.filter(
                                      (p) => !(selectedModule === 'rule_engine_module' && (p.name === 'edit_rule' || p.name === 'delete_rule') && userRole !== 'dev_admin' && selectedRole !== 'dev_admin')
                                    ) || [];
                                    const allEnabled = visiblePermissions.length > 0 && visiblePermissions.every(
                                      (p) => modulePermissions[p.name]
                                    );
                                    return allEnabled ? "All Permissions Granted" : "Grant All Permissions";
                                  })()}
                                </Text>
                                <Switch
                                  checked={
                                    (() => {
                                      const visiblePermissions = ENTITIES[selectedModule]?.permissions?.filter(
                                        (p) => !(selectedModule === 'rule_engine_module' && (p.name === 'edit_rule' || p.name === 'delete_rule') && userRole !== 'dev_admin' && selectedRole !== 'dev_admin')
                                      ) || [];
                                      return visiblePermissions.length > 0 && visiblePermissions.every((p) => modulePermissions[p.name]);
                                    })()
                                  }
                                  size={window.innerWidth <= 480 ? "small" : "default"}
                                  onChange={(checked) => {
                                    const moduleName = ENTITIES[selectedModule]?.displayName || selectedModule;
                                    Modal.confirm({
                                      title: checked ? 'Grant All Permissions' : 'Revoke All Permissions',
                                      content: checked
                                        ? `Are you sure you want to grant ALL permissions for "${moduleName}"?`
                                        : `Are you sure you want to revoke ALL permissions for "${moduleName}"?`,
                                      okText: checked ? 'Yes, Grant All' : 'Yes, Revoke All',
                                      cancelText: 'Cancel',
                                      okType: checked ? 'primary' : 'danger',
                                      okButtonProps: checked ? { style: { backgroundColor: '#f58220', borderColor: '#f58220', color: 'white' } } : {},
                                      onOk: () => {
                                        const newPermissions = { ...modulePermissions };
                                        ENTITIES[selectedModule]?.permissions?.forEach((p) => {
                                          const isRestricted = selectedModule === 'rule_engine_module' && (p.name === 'edit_rule' || p.name === 'delete_rule') && userRole !== 'dev_admin' && selectedRole !== 'dev_admin';
                                          if (!isRestricted) {
                                            newPermissions[p.name] = checked;
                                          }
                                        });
                                        setModulePermissions(newPermissions);
                                        const changed = Object.entries(newPermissions).some(
                                          ([key, val]) => initialPermissions[key] !== val
                                        );
                                        setHasChanges(changed);
                                      },
                                    });
                                  }}
                                />
                              </div>
                            )}
                            {ENTITIES[selectedModule]?.permissions
                              ?.filter((permission) => !(selectedModule === 'rule_engine_module' && (permission.name === 'edit_rule' || permission.name === 'delete_rule') && userRole !== 'dev_admin' && selectedRole !== 'dev_admin'))
                              ?.map((permission) => (
                                <div
                                  key={permission.name}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: window.innerWidth <= 480 ? "flex-start" : "center",
                                    flexDirection: window.innerWidth <= 480 ? "column" : "row",
                                    padding: window.innerWidth <= 480 ? "10px" : "12px",
                                    border: "1px solid #f0f0f0",
                                    borderRadius: 6,
                                    marginBottom: 8,
                                    background: "#fafafa"
                                  }}
                                >
                                  <div style={{
                                    marginBottom: window.innerWidth <= 480 ? 8 : 0,
                                    width: window.innerWidth <= 480 ? "100%" : "auto"
                                  }}>
                                    <Text strong style={{
                                      display: "block",
                                      marginBottom: 4,
                                      fontSize: window.innerWidth <= 480 ? 13 : 14
                                    }}>
                                      {permission.displayName}
                                    </Text>
                                    <Text type="secondary" style={{
                                      fontSize: window.innerWidth <= 480 ? 11 : 12
                                    }}>
                                      {permission.name}
                                    </Text>
                                  </div>
                                  <div style={{
                                    display: "flex",
                                    justifyContent: window.innerWidth <= 480 ? "flex-end" : "center",
                                    width: window.innerWidth <= 480 ? "100%" : "auto"
                                  }}>
                                    <Switch
                                      checked={modulePermissions[permission.name] || false}
                                      onChange={(checked) => handlePermissionToggle(permission.name, checked)}
                                      size={window.innerWidth <= 480 ? "small" : "default"}
                                    />
                                  </div>
                                </div>
                              ))}

                            {(!ENTITIES[selectedModule]?.permissions || ENTITIES[selectedModule]?.permissions?.length === 0) && (
                              <Empty
                                description={`No permissions available for ${ENTITIES[selectedModule]?.displayName}`}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </div>
                        )}
                      </Card>
                    ) : (
                      <Card style={{
                        height: window.innerWidth <= 768 ? "200px" : "500px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        <Empty
                          description={
                            <span style={{
                              fontSize: window.innerWidth <= 480 ? 12 : 14
                            }}>
                              Select a module from the {window.innerWidth <= 768 ? "above" : "left"} to view permissions
                            </span>
                          }
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                      </Card>
                    )}
                  </Col>
                </Row>
              </Card>
            ) : (
              <Card style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}>
                <div style={{
                  textAlign: "center",
                  padding: window.innerWidth <= 480 ? "40px 20px" : "60px"
                }}>
                  <Empty
                    description={
                      <div>
                        <Text style={{
                          fontSize: window.innerWidth <= 480 ? 16 : 18,
                          color: "#595959",
                          display: "block",
                          marginBottom: 8
                        }}>
                          Select a role to manage permissions
                        </Text>
                        <Text type="secondary" style={{
                          fontSize: window.innerWidth <= 480 ? 12 : 14
                        }}>
                          Start typing in the search box above to find roles
                        </Text>
                      </div>
                    }
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              </Card>
            )}
          </div>
        </div>
      </Dashboard>
    </StyledAdmin>
  );
};

export default Admin;
